import { snackbarReducer } from './Snackbar.slice';

export const getSnackbarModule = () => ({
  id: 'SnackbarModule',
  reducerMap: {
    snackbar: snackbarReducer,
  },
  sagas: [],
});
